import script from "./SelectDataType.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDataType.vue?vue&type=script&setup=true&lang=js"

import "./SelectDataType.vue?vue&type=style&index=0&id=5bc08a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc08a8a"]])

export default __exports__